module.exports = __webpack_public_path__ + "static/media/csc-logo.529cc020.png";